import React, { useState, useEffect } from 'react';
import CustomSelect from '../Forms/Element/CustomSelect';

const YearSelect = (props) => {

    const [options, setOptions] = useState([]);
    const { startYear, endYear } = props;

    useEffect(() => {
        const yearList = [];
        for (let year = startYear; year <= endYear; year++) {
            yearList.push({ value: year, label: year });
        }
        setOptions(yearList);
    }, [startYear, endYear]);

    return (
        <CustomSelect
            options={options}
            {...props} />
    );
}

export default YearSelect;